import React from "react";

import styled from "styled-components";
import { useSelector } from "react-redux";
import {
    PathwayCenteredTableCellContent,
    PathwayCenteredTableHeader,
    PathwayTable,
    PathwayTableCellContent,
    PathwayTableContentRow,
    PathwayTableHeader,
    PathwayTableHeaderRow,
    TableContentDividerLine,
} from "../../../_UI/StyledComponents/PathwayTable";
import { PathwayAddButton, PathwayDeleteButton, PathwayEditButton } from "../../../_UI/Components/PathwayButtons";
import { getClientNameForConnectedAuthData, mapConnectAuthDataTypeToIntegrationName } from "../services/client.mapper";

const APIConnectionContent = (props) => {
    const clientReducer = useSelector((state) => state.client);

    return (
        <PathwayTable>
            <TableHeader>
                <PathwayTableHeader>Integration</PathwayTableHeader>
                <PathwayTableHeader>Name</PathwayTableHeader>
                <PathwayTableHeader>Url</PathwayTableHeader>
                <PathwayTableHeader>Shop / Account</PathwayTableHeader>
                <PathwayCenteredTableHeader>
                    <PathwayAddButton onClick={props.createNewConnectedAuthDataWithoutClient} />
                </PathwayCenteredTableHeader>
            </TableHeader>
            {clientReducer.usedConnectedAuthData.map((connectedAuthData) => (
                <>
                    <TableRow key={connectedAuthData.externalUUID}>
                        <PathwayTableCellContent>
                            {mapConnectAuthDataTypeToIntegrationName(connectedAuthData.type)}
                        </PathwayTableCellContent>
                        <PathwayTableCellContent>{connectedAuthData.title}</PathwayTableCellContent>
                        <PathwayTableCellContent>{connectedAuthData.endpoint}</PathwayTableCellContent>
                        <PathwayTableCellContent>
                            {getClientNameForConnectedAuthData(clientReducer.clients, connectedAuthData)}
                        </PathwayTableCellContent>
                        <PathwayCenteredTableCellContent>
                            <ButtonArea>
                                <PathwayEditButton
                                    onClick={() => props.openEditConnectedAuthDataModal(connectedAuthData)}
                                />
                                <PathwayDeleteButton
                                    onClick={() => props.openDeleteConnectedAuthDataModal(connectedAuthData)}
                                />
                            </ButtonArea>
                        </PathwayCenteredTableCellContent>
                    </TableRow>
                    <TableContentDividerLine />
                </>
            ))}
        </PathwayTable>
    );
};

export default APIConnectionContent;

const TableHeader = styled(PathwayTableHeaderRow)`
    grid-template-columns: 0.125fr 0.225fr 0.25fr 0.3fr 0.1fr;
`;

const TableRow = styled(PathwayTableContentRow)`
    grid-template-columns: 0.125fr 0.225fr 0.25fr 0.3fr 0.1fr;
`;

const ButtonArea = styled.div`
    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
    column-gap: var(--gap-s);
`;
